"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDynamicCodeResetLoginPwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var dynamicCode_1 = require("../../model/dynamicCode");
var service_1 = require("../../../library/base/service");
var GetDynamicCodeResetLoginPwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetDynamicCodeResetLoginPwd, _super);
    function GetDynamicCodeResetLoginPwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '重置登录密码发送验证码接口';
        _this.code = '101070';
        _this.desc = '重置登录密码发送验证码接口';
        _this.requestParams = new dynamicCode_1.GetDynamicCodeResetLoginPwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetDynamicCodeResetLoginPwd;
}(service_1.BaseService));
exports.GetDynamicCodeResetLoginPwd = GetDynamicCodeResetLoginPwd;
//# sourceMappingURL=getDynamicCodeResetLoginPwd.js.map